import { render } from "./GroupAttachProject.vue?vue&type=template&id=2b036783"
import script from "./GroupAttachProject.vue?vue&type=script&lang=js"
export * from "./GroupAttachProject.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__